<template>
  <div class="sales-statistics">


    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="老师统计" name="first">
        <el-form class="select">

            <el-form-item label="教师姓名:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择"
                v-model="teacherName"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in teacherArr"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                >
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="课消次数:" label-width="100px" style="width: 30%;">
              <el-input
                placeholder="请输入课消次数"
                v-model="cancellationsNumber"
                :onkeyup="cancellationsNumber = cancellationsNumber.replace(/[\u4E00-\u9FA5]/g,'')"
                style="width: 100%"
                clearable
              ></el-input>
            </el-form-item>


            <el-form-item label="课消金额:" label-width="100px" style="width: 30%;">
              <el-input
                placeholder="请输入课消金额"
                v-model="cancellationsMoney"
                :onkeyup="cancellationsMoney = cancellationsMoney.replace(/[\u4E00-\u9FA5]/g,'')"
                style="width: 100%"
                clearable
              ></el-input>
            </el-form-item>


            <el-form-item label="日期:" label-width="100px" style="width: 50%;text-align: justify;">
              <el-date-picker
                v-model="dateTimeList"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="所在地域:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择所在地域"
                v-model="regionName"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in optionsListt"
                  :key="item.id"
                  :value="item.dictType"
                  :label="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item>




            <el-form-item style="width: 100%;">
              <div style="display: flex;">
                <div style="width: 55%;">

                    <div style="display: flex;">
                      <span
                      style="
                        font-weight: 900;
                        font-family: cursive;
                        width: 400px;
                        background-color: #f58c4b;
                        height: 30px;
                        border-radius: 10px;
                        padding: 5px 0px;
                        margin-bottom: 10px;
                        text-align: start;
                        line-height: 26px;
                        padding-left: 10px;
                        margin-left: 100px;
                        padding-left: 17px;
                      "
                    > 实际课消次数:{{ dataTop.actualNumCount }} </span>

                    <span
                      style="
                        font-weight: 900;
                        font-family: cursive;
                        width: 400px;
                        background-color: #d1c633;
                        height: 30px;
                        border-radius: 10px;
                        padding: 5px 0px;
                        margin-bottom: 10px;
                        text-align: start;
                        line-height: 26px;
                        padding-left: 10px;
                        margin-left: 100px;
                        padding-left: 17px;
                      "
                    > 实际课消金额:{{ dataTop.actualMoneyCount }} </span>

                    </div>


                    <div style="display: flex;">
                      <span
                        style="
                          font-weight: 900;
                          font-family: cursive;
                          width: 400px;
                          background-color: rgb(150 233 149);
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 未课消次数：{{ dataTop.notNumCount }} </span>


                      <span
                        style="
                          font-weight: 900;
                          font-family: cursive;
                          width: 400px;
                          background-color: #c2f54b;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 未课消金额：{{ dataTop.notMoneyCount }} </span>
                    </div>


                    <div style="display: flex;">
                      <span
                        style="
                          font-weight: 900;
                          font-family: cursive;
                          width: 400px;
                          background-color: #5deb9e;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 预课消总次数：{{ dataTop.estimateNumCount }} </span>


                      <span
                        style="
                          font-weight: 900;
                          font-family: cursive;
                          width: 400px;
                          background-color: #e39a59;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 预课消总金额: {{ dataTop.estimateMoneyCount }} </span>

                    </div>



                  </div>
                <div style="display: flex;width: 55%; flex-wrap: wrap;">
                    <div style="width: 100%;text-align: end;">
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-thumb" @click="exportBtnss">一键课消</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
                    </div>
                    <div style="width: 100%;display: flex;">
                      <div style="margin-left: 40%;width: 100px;">排序规则:</div>
                      <el-select  placeholder="请选择排序规则"  v-model="sortingRules" @change="changeSortingRules" style="width: 50%;"  clearable  filterable>
                        <el-option  v-for="item in sortingRulesArr"  :key="item.id"  :value="item.id"  :label="item.realname"> </el-option>
                      </el-select>
                    </div>
                </div>
              </div>
            </el-form-item>


            </el-form>



            <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataList" border height="400">
            <el-table-column prop="teacherName" label="教师姓名" ></el-table-column>
            <el-table-column prop="regionName" label="所在地域" width="100"></el-table-column>
            <el-table-column prop="totalSalesNum" label="实际课消次数" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(245, 140, 75);font-size: 25px;font-weight: 900;">{{scope.row.totalSalesNum}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="notNum" label="未课消次数" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(150, 233, 149);font-size: 25px;font-weight: 900;">{{scope.row.notNum}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="estimateNum" label="预课消总次数" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(93, 235, 158);font-size: 25px;font-weight: 900;">{{scope.row.estimateNum}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="allMoney" label="实际课消金额" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(209, 198, 51);font-size: 25px;font-weight: 900;">{{scope.row.allMoney}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="notMoney" label="未课消金额" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(194, 245, 75);font-size: 25px;font-weight: 900;">{{scope.row.notMoney}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="estimateMoney" label="预课消总金额" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(227, 154, 89);font-size: 25px;font-weight: 900;">{{scope.row.estimateMoney}}</span>
              </template> -->
            </el-table-column>
            <el-table-column header-align="center" label="查看详情" >
              <template slot-scope="scope">
                <el-button type="text" @click="details(scope.row)">详情</el-button>
              </template>
            </el-table-column>
            </el-table>



            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
            layout="prev, pager, next,sizes, jumper" :total="requestParameters.total">
            </el-pagination>


            <el-card v-if="ShowCourseSalesStatisticsDetails" style="position: fixed;width: 100%;top: 70px; height: 100%;left: 0;z-index: 111;">
              <CourseSalesStatisticsDetails :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButs"></CourseSalesStatisticsDetails>
            </el-card>
      </el-tab-pane>
      <el-tab-pane label="学生统计" name="second">
        <el-form class="select">

          <!-- <el-form-item label="教师姓名:" label-width="100px" style="width: 30%;">
            <el-select
              placeholder="请选择"
              v-model="teacherName"
              style="width: 100%"
              clearable
              filterable
            >
              <el-option
                v-for="item in teacherArr"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
              >
              </el-option>
            </el-select>
          </el-form-item> -->


          <el-form-item label="线下学员:" label-width="100px" style="width: 30%;">
                <el-select
                  placeholder="请选择学员"
                  v-model="student"
                  style="width: 100%"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in getStudentsArr"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname"
                  >
                  </el-option>
                </el-select>
          </el-form-item>

          <el-form-item label="规划学员:" label-width="100px" style="width: 30%;">
                <el-select
                  placeholder="请选择学员"
                  v-model="student_s"
                  style="width: 100%"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in getStudentsArr_s"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname"
                  >
                  </el-option>
                </el-select>
          </el-form-item>



          <el-form-item label="课消次数:" label-width="100px" style="width: 30%;">
            <el-input
              placeholder="请输入课消次数"
              v-model="cancellationsNumber_s"
              :onkeyup="cancellationsNumber_s = cancellationsNumber_s.replace(/[\u4E00-\u9FA5]/g,'')"
              style="width: 100%"
              clearable
            ></el-input>
          </el-form-item>


          <el-form-item label="课消金额:" label-width="100px" style="width: 30%;">
            <el-input
              placeholder="请输入课消金额"
              v-model="cancellationsMoney_s"
              :onkeyup="cancellationsMoney_s = cancellationsMoney_s.replace(/[\u4E00-\u9FA5]/g,'')"
              style="width: 100%"
              clearable
            ></el-input>
          </el-form-item>


          <el-form-item label="日期:" label-width="100px" style="width: 30%;">
            <el-date-picker
            v-model="dateTimeList_s"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="所在地域:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择所在地域"
                v-model="regionName"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in optionsListt"
                  :key="item.id"
                  :value="item.dictType"
                  :label="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item>






          <el-form-item style="width: 100%;">
            <div style="display: flex;">
              <div style="width: 55%;">
                <div style="display: flex;">
                      <span
                      style="
                        font-weight: 900;
                        font-family: cursive;
                        width: 400px;
                        background-color: #f58c4b;
                        height: 30px;
                        border-radius: 10px;
                        padding: 5px 0px;
                        margin-bottom: 10px;
                        text-align: start;
                        line-height: 26px;
                        padding-left: 10px;
                        margin-left: 100px;
                        padding-left: 17px;
                      "
                    > 实际课消次数:{{ dataTop_s.actualNumCount }} </span>

                    <span
                      style="
                        font-weight: 900;
                        font-family: cursive;
                        width: 400px;
                        background-color: #d1c633;
                        height: 30px;
                        border-radius: 10px;
                        padding: 5px 0px;
                        margin-bottom: 10px;
                        text-align: start;
                        line-height: 26px;
                        padding-left: 10px;
                        margin-left: 100px;
                        padding-left: 17px;
                      "
                    > 实际课消金额:{{ dataTop_s.actualMoneyCount }} </span>

                    </div>


                    <div style="display: flex;">
                      <span
                        style="
                          font-weight: 900;
                          font-family: cursive;
                          width: 400px;
                          background-color: rgb(150 233 149);
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 未课消次数：{{ dataTop_s.notNumCount }} </span>


                      <span
                        style="
                          font-weight: 900;
                          font-family: cursive;
                          width: 400px;
                          background-color: #c2f54b;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 未课消金额：{{ dataTop_s.notMoneyCount }} </span>
                    </div>


                    <div style="display: flex;">
                      <span
                        style="
                          font-weight: 900;
                          font-family: cursive;
                          width: 400px;
                          background-color: #5deb9e;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 预课消总次数：{{ dataTop_s.estimateNumCount }} </span>


                      <span
                        style="
                          font-weight: 900;
                          font-family: cursive;
                          width: 400px;
                          background-color: #e39a59;
                          height: 30px;
                          border-radius: 10px;
                          padding: 5px 0px;
                          margin-bottom: 10px;
                          text-align: start;
                          line-height: 26px;
                          padding-left: 10px;
                          margin-left: 100px;
                          padding-left: 17px;
                        "
                      > 预课消总金额: {{ dataTop_s.estimateMoneyCount }} </span>

                    </div>



              </div>

              <div style="display: flex;width: 55%; flex-wrap: wrap;">
                    <div style="width: 100%;text-align: end;">
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-thumb" @click="exportBtnss">一键课消</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
                    </div>
                    <div style="width: 100%;display: flex;">
                      <div style="margin-left: 40%;width: 100px;">排序规则:</div>
                      <el-select  placeholder="请选择排序规则"  v-model="sortingRuless" @change="changeSortingRuless" style="width: 50%;"  clearable  filterable>
                        <el-option  v-for="item in sortingRulesArr"  :key="item.id"  :value="item.id"  :label="item.realname"> </el-option>
                      </el-select>
                    </div>
              </div>



            </div>
          </el-form-item>


          </el-form>



          <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataList_s" border height="400">
            <el-table-column prop="studentName" label="学生姓名" ></el-table-column>
            <el-table-column prop="regionName" label="所在地域" width="100"></el-table-column>
            <el-table-column prop="totalSalesNum" label="实际课消次数" >
                <!-- <template slot-scope="scope">
                  <span style="color:rgb(245, 140, 75);font-size: 25px;font-weight: 900;">{{scope.row.totalSalesNum}}</span>
                </template> -->
            </el-table-column>
            <el-table-column prop="notNum" label="未课消次数" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(150, 233, 149);font-size: 25px;font-weight: 900;">{{scope.row.notNum}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="estimateNum" label="预课消总次数" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(93, 235, 158);font-size: 25px;font-weight: 900;">{{scope.row.estimateNum}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="allMoney" label="实际课消金额" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(209, 198, 51);font-size: 25px;font-weight: 900;">{{scope.row.allMoney}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="notMoney" label="未课消金额" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(194, 245, 75);font-size: 25px;font-weight: 900;">{{scope.row.notMoney}}</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="estimateMoney" label="预课消总金额" >
              <!-- <template slot-scope="scope">
                <span style="color:rgb(227, 154, 89);font-size: 25px;font-weight: 900;">{{scope.row.estimateMoney}}</span>
              </template> -->
            </el-table-column>
          <el-table-column header-align="center" label="查看详情" >
            <template slot-scope="scope">
              <el-button type="text" @click="details_s(scope.row)">详情</el-button>
            </template>
          </el-table-column>
          </el-table>



          <el-pagination @size-change="handleSizeChange_s" @current-change="handleCurrentChange_s"
          :current-page="requestParameters_s.pageNum" :page-size="requestParameters_s.pageSize"
          layout="prev, pager, next,sizes, jumper" :total="requestParameters_s.total">
          </el-pagination>


          <el-card v-if="ShowCourseSalesStatisticsDetails_s" style="position: fixed;width: 100%;top: 70px; height: 100%;left: 0;z-index: 111;">
            <CourseSalesStatisticsDetails_s :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButs"></CourseSalesStatisticsDetails_s>
          </el-card>
      </el-tab-pane>

      <el-tab-pane label="实际课消统计" name="actualCourseConsumptionStatistics">

        <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
          <div class="glow-effect" style="width: 22%; height: 100px; border: 1px solid #0fb2f6;" @click="handleClickTab(1)">
            <div style="font-size: 25px;color: #18dec5; font-weight: 900; margin: 15px 0px 10px 0px;">{{ TotalAmountOfCourseCancellations }}</div>
            <div class="clickable-text">课程待消总额</div>
          </div>
          <div class="glow-effect" style="width: 22%;height: 100px; border: 1px solid #0fb2f6;" @click="handleClickTab(2)">
            <div style="font-size: 25px;color: #18dec5; font-weight: 900; margin: 15px 0px 10px 0px;">{{ TotalCourseHoursToBeCancelled }}</div>
            <div class="clickable-text">课程待消总课时</div>
          </div>
          <div class="glow-effect" style="width: 22%;height: 100px; border: 1px solid #0fb2f6;" @click="handleClickTab(3)">
            <div style="font-size: 25px;color: #18dec5; font-weight: 900; margin: 15px 0px 10px 0px;">{{ TodaysTotalAmountOfNewlyAddedClassExpenses }}</div>
            <div class="clickable-text">今日新增课消总额</div>
          </div>
          <div class="glow-effect" style="width: 22%;height: 100px; border: 1px solid #0fb2f6;" @click="handleClickTab(4)">
            <div style="font-size: 25px;color: #18dec5; font-weight: 900; margin: 15px 0px 10px 0px;">{{ TodaysNewlyAddedClassHours }}</div>
            <div class="clickable-text">今日新增课时数</div>
          </div>
        </div>

        <div style="margin-bottom: 20px;text-align: end;">
          <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-thumb" @click="handleOnekeyCourseConsumption">一键课消</el-button>
        </div>

        <el-table v-if="typeCourseConsumptionStatistics === 1"  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataListactualCourseConsumptionStatistics" border height="400">
            <el-table-column prop="studentName" header-align="center"  label="学生姓名" ></el-table-column>
            <el-table-column prop="moneySum" header-align="center"  label="总课消金额" ></el-table-column>
            <el-table-column prop="moneyResidue" header-align="center"  label="剩余总金额" ></el-table-column>
            <el-table-column prop="moneyYet" header-align="center"  label="已课消金额" ></el-table-column>
            <el-table-column header-align="center" label="操作" width="150px">
              <template slot-scope="scope">
                <el-button type="text" @click="details_s(scope.row)">详情</el-button>
              </template>
            </el-table-column>
        </el-table>


        <el-table v-if="typeCourseConsumptionStatistics === 2"  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataListactualCourseConsumptionStatistics" border height="400">
            <el-table-column prop="studentName" header-align="center"  label="学生姓名" ></el-table-column>
            <el-table-column prop="hourNumber" header-align="center"  label="学业课课时数" ></el-table-column>
            <el-table-column prop="familyHourResidue" header-align="center"  label="家庭教育课剩余课时数" ></el-table-column>
            <el-table-column prop="familyHourYet" header-align="center"  label="家庭教育课已课消课时数" ></el-table-column>
            <el-table-column prop="familyHourNumber" header-align="center"  label="家庭教育课课时数" ></el-table-column>
            <el-table-column prop="hourSum" header-align="center"  label="总课时数" ></el-table-column>
            <el-table-column prop="hourResidue" header-align="center"  label="学业剩余课时数" ></el-table-column>
            <el-table-column prop="hourYet" header-align="center"  label="学业已消课时数" ></el-table-column>
            <el-table-column header-align="center" label="操作" width="150px">
              <template slot-scope="scope">
                <el-button type="text" @click="details_s(scope.row)">详情</el-button>
              </template>
            </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChangealCourseConsumptionStatistics" @current-change="handleCurrentChangealCourseConsumptionStatistics"
          :current-page="requestParametersalCourseConsumptionStatistics.pageNum" :page-size="requestParametersalCourseConsumptionStatistics.pageSize"
          layout="prev, pager, next,sizes, jumper" :total="requestParametersalCourseConsumptionStatistics.total"> </el-pagination>


        <el-card v-if="ShowCourseSalesStatisticsDetails_s" style="position: fixed;width: 100%;top: 70px; height: 100%;left: 0;z-index: 111;">
          <CourseSalesStatisticsDetails_s :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButs"></CourseSalesStatisticsDetails_s>
        </el-card>

      </el-tab-pane>

    </el-tabs>




  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
import CourseSalesStatisticsDetails from './CourseSalesStatisticsDetails'
import CourseSalesStatisticsDetails_s from './CourseSalesStatisticsDetails_s'
import { getTeachers_s,  } from "@/api/firstClassApi";
import {  getStudentsType } from "@/api/fiveClassApi"
import Vue from 'vue';
import { ref, reactive, onMounted, getCurrentInstance, nextTick, onUpdated  } from '@vue/composition-api'
var $Vue = Vue.prototype
import { useStore } from '../../pinia/stores.js'
import { Loading } from 'element-ui';



export default {
  components:{
    CourseSalesStatisticsDetails,
    CourseSalesStatisticsDetails_s
  },

  setup(props, { root, refs }) {


    let activeName =  ref('first')
    let getStudentsArr = ref([])
    let getStudentsArr_s = ref([])
    let student_s = ref("")
    let student = ref("")
    let requestParameters = reactive({ pageSize: 10, pageNum: 1,  total: 0,})
    let dateTimeList = ref(getMonthRange()) // 默认当月
    let dateTimeList_s = ref(getMonthRange()) // 默认当月
    // let dateTimeList = ref(getMonthRange())
    // let dateTimeList_s = ref(getMonthRange())
    let teacherName = ref("")
    let cancellationsNumber_s = ref("")
    let cancellationsMoney_s = ref("")
    let cancellationsNumber = ref("")
    let cancellationsMoney = ref("")
    let dataList = ref([])
    let dataList_s = ref([])
    let teacherArr = ref([])
    let ShowCourseSalesStatisticsDetails = ref(false)
    let ShowCourseSalesStatisticsDetails_s = ref(false)
    let DetailsRow = reactive({})
    let TimeList = ref([])
    let typeCourseConsumptionStatistics = ref(1)
    let dataTop = reactive({ actualNumCount: 0, actualMoneyCount: 0,  notNumCount: 0,  notMoneyCount: 0, estimateNumCount: 0, estimateMoneyCount: 0})
    let dataTop_s = reactive({ actualNumCount: 0, actualMoneyCount: 0,  notNumCount: 0,  notMoneyCount: 0, estimateNumCount: 0, estimateMoneyCount: 0})
    let requestParameters_s = reactive({ pageSize: 10, pageNum: 1,  total: 0,})
    let requestType = ref('')

    const instance = getCurrentInstance()
    let dataListactualCourseConsumptionStatistics = ref([])
    let requestParametersalCourseConsumptionStatistics = reactive({ pageSize: 10, pageNum: 1,  total: 0,})

    let TotalAmountOfCourseCancellations = ref(0)
    let TotalCourseHoursToBeCancelled = ref(0)
    let TodaysTotalAmountOfNewlyAddedClassExpenses = ref(0)
    let TodaysNewlyAddedClassHours = ref(0)

    let sortingRules = ref(1)
    let sortingRulesArr = ref([{ id:1, realname:'按实际课消金额排序'},{id:2, realname:'按预课消金额排序'}])
    let sortingRuless = ref(1)

    let regionName = ref('')
    let optionsListt = ref([
        {dictValue:"北京", dictType:1 },
        {dictValue:"深圳", dictType:2 },
      ])

    onMounted(()=>{

        getListData()
        //  dataList.value = [{ ownerDate: '2024-11-31', teacherName:'卷柏', classNum:'123' }]
        handleGetTeacher()
        getStudentsType(2).then((res) => {  getStudentsArr.value = res.data })
        getStudentsType(1).then((res) => {  getStudentsArr_s.value = res.data })

        getOptionsList()

    })


    onUpdated(() => {
        nextTick(() => {
            handleInit()

            let cellDom = document.querySelectorAll('.cell')

            for (let element of cellDom) {
                // if(element.innerHTML === '实际课消次数'){
                //     element.style.color = 'rgb(245, 140, 75)'
                // }
                // if(element.innerHTML === '实际课消金额'){
                //     element.style.color = 'rgb(209, 198, 51)'
                // }
                // if(element.innerHTML === '未课消次数'){
                //     element.style.color = 'rgb(150, 233, 149)'
                // }
                // if(element.innerHTML === '未课消金额'){
                //     element.style.color = 'rgb(194, 245, 75)'
                // }
                // if(element.innerHTML === '预课消总次数'){
                //     element.style.color = 'rgb(93, 235, 158)'
                // }
                // if(element.innerHTML === '预课消总金额'){
                //     element.style.color = 'rgb(227, 154, 89)'
                // }

            }

        })
    })

    function getMonthRange() {
      const now = new Date()
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)

      const format = date => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }

      return [format(firstDay), format(lastDay)]
    }

    const getOptionsList = () => {
      axios.get(`${ apiBaseUrl }/dict//getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
        optionsListt.value = res.data.data
        console.log("%c Line:760 🥓 optionsListt.value", "color:#7f2b82", optionsListt.value);
      })
    }

    const getOptions = () => {
        return request({
            url: '/api/manager/courseSalesStatistics/getOptions',
            method: 'get'
        })
    }

    const getTableData = () => {
        getTableDataList().then(res => {
            if (res.code === 200) {
                tableData.value = res.data
            }
        })
    }

    const formatDate = (date) =>{
        return date.toISOString().split('T')[0];
    }

    const handleInit = () =>{
        const today = new Date()
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 2)
        const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1)


        let firstDayOfMonthNew = formatDate(firstDayOfMonth)
        let lastDayOfMonthNew = formatDate(lastDayOfMonth)

      setTimeout(()=>{
          // dateTimeList.value[0] = firstDayOfMonthNew
          // dateTimeList.value[1] = lastDayOfMonthNew
          // dateTimeList_s.value[0] = firstDayOfMonthNew
          // dateTimeList_s.value[1] = lastDayOfMonthNew
      },1000)
    }

    const handleClick = (tab, event) =>{
          if(tab.paneName === 'first'){
            requestType.value = ''
            sortingRuless.value = 1
            handleTpyeCler(tab.paneName)
          }
          if(tab.paneName === 'second'){
            requestType.value = 'requestType'
            sortingRules.value = 1
            handleTpyeCler(tab.paneName)
          }

          if(tab.paneName === 'actualCourseConsumptionStatistics'){
            axios.get(`${apiBaseUrl}/reality_classSales/findCollect`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {

                if(response.data.code == 200){
                  const data = response.data
                  TotalAmountOfCourseCancellations.value = data.data.courseStayMoney
                  TotalCourseHoursToBeCancelled.value = data.data.courseStayHour
                  TodaysTotalAmountOfNewlyAddedClassExpenses.value = data.data.todayClassSalesMoney
                  TodaysNewlyAddedClassHours.value = data.data.todayClassSalesHour
                }else{
                  TotalAmountOfCourseCancellations.value = 0
                  TotalCourseHoursToBeCancelled.value = 0
                  TodaysTotalAmountOfNewlyAddedClassExpenses.value = 0
                  TodaysNewlyAddedClassHours.value = 0
                }

            }).catch(error => {
                handleMessage(error, 'error')
            })
            handleInitList(tab.paneName)
          }

    }


    const handleInitList = (value) =>{
      getListDataalCourseConsumptionStatistics()
    }


    const handleTpyeCler = (bomb) =>{
        const _mr = getMonthRange()
        dateTimeList.value[0] = _mr[0]
        dateTimeList.value[1] = _mr[1]
        dateTimeList_s.value[0] = _mr[0]
        dateTimeList_s.value[1] = _mr[1]

        if(bomb === 'first'){
            clearBtns()
        }else{
            handleCler()
        }
    }

    const handleCler = () =>{
      cancellationsNumber_s.value = ""
      cancellationsMoney_s.value = ""
      // dateTimeList_s.value = []
      student_s.value = ""
      student.value = ""


      let str = []
      if(student.value){
        str.push(student.value)
        if(student_s.value){
          str.push(student_s.value)
        }
      }else{
        if(student_s.value){
          str.push(student_s.value)
        }
      }

      if(dateTimeList_s.value && dateTimeList_s.value.length > 0){
        let data = {
            pageNo: 1,
            pageSize:  10,
            studentList: str.length > 0 ? str : null,
            startTime: dateTimeList_s.value[0],
            endTime: dateTimeList_s.value[1],
            salesNum: cancellationsNumber_s.value,
            salesMoney: cancellationsMoney_s.value,
            sortingRules: sortingRuless.value,
        }

        getListData(data)
      }else{
        let data = {
              pageNo:  1,
              pageSize:  10,
              studentList:  str.length > 0 ? str : null,
              startTime: getMonthRange()[0],
              endTime: getMonthRange()[1],
              salesNum: cancellationsNumber_s.value,
              salesMoney: cancellationsMoney_s.value,

            }
          getListData(data)
      }

    }

    let exportBtns = () =>{

      if(requestType.value === 'requestType'){
          let str = []
          if(student.value){
            str.push(student.value)
            if(student_s.value){
              str.push(student_s.value)
            }
          }else{
            if(student_s.value){
                str.push(student_s.value)
            }
          }
          let data = {
              studentList: str.length > 0 ? str : null,
              startTime: dateTimeList_s.value[0],
              endTime: dateTimeList_s.value[1],
              salesNum: cancellationsNumber_s.value,
              salesMoney: cancellationsMoney_s.value,

              sortingRules: sortingRules.value,
              pageNo: 1,
              pageSize: 10000,
              teacherId: teacherName.value,
              regionName:regionName.value || localStorage.getItem('cityTepy'),



          }
          axios.post(`${apiBaseUrl}/classSales/excelStuClassSales`, data, { responseType: "blob",
          headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
            if(response.status == 200){

              const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
              const downloadLink = document.createElement("a");
              downloadLink.href = URL.createObjectURL(blob);
              downloadLink.download = "课消统计(学生统计).xlsx";
              downloadLink.click();

              handleMessage('导出成功', 'success')
            }else{
              handleMessage('导出失败', 'error')
            }
          })
      }else{
        let data = {
          teacherId: teacherName.value,
          // courseStartTime: dateTimeList.value[0],
          // courseEndTime: dateTimeList.value[1],
          startTime: dateTimeList.value[0],
          endTime: dateTimeList.value[1],
          salesNum: cancellationsNumber.value,
          salesMoney: cancellationsMoney.value,


          sortingRules: sortingRules.value,
          pageNo: 1,
          pageSize: 10000,
          teacherId: teacherName.value,
          regionName:regionName.value || localStorage.getItem('cityTepy'),
        }
        axios.post(`${apiBaseUrl}/classSales/excelClassSales`, data, { responseType: "blob",
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')

        } }).then(response => {
          if(response.status == 200){

            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = "课消统计(老师统计).xlsx";
            downloadLink.click();

            handleMessage('导出成功', 'success')
          }else{
            handleMessage('导出失败', 'error')
          }
        })
      }


    }

    let exportBtnss = () =>{
      axios.get(`${apiBaseUrl}/classSales/createClassSales`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(response => {
          if(response.data.code == 200){
            let data = {
              pageNo: requestParameters.pageNum ? requestParameters.pageNum : 1,
              pageSize: requestParameters.pageSize,
            }

            handleMessage('操作成功', 'success')

            setTimeout(()=>{
              getListData(data)
            },1000)

          }else{
            handleMessage('操作失败', 'error')
          }
      })
    }

    let clearBtns = () =>{
      if(requestType.value !== 'requestType'){
          // dateTimeList.value = []
          teacherName.value = ""
          cancellationsNumber.value = ""
          cancellationsMoney.value = ""
          regionName.value = ""


        if(dateTimeList.value && dateTimeList.value.length > 0){
          let data = {
            pageNo: 1,
            pageSize: 10,
            teacherId: teacherName.value,
            // courseStartTime: dateTimeList.value[0],
            // courseEndTime: dateTimeList.value[1],
            startTime: dateTimeList.value[0],
            endTime: dateTimeList.value[1],
            salesNum: cancellationsNumber.value,
            salesMoney: cancellationsMoney.value,
            sortingRules: sortingRules.value,
          }

          getListData(data)
        }else{
            let data = {
              pageNo:  1,
              pageSize: 10,
              teacherId: teacherName.value,
              startTime: getMonthRange()[0],
              endTime: getMonthRange()[1],
              salesNum: cancellationsNumber.value,
              salesMoney: cancellationsMoney.value,
              sortingRules: sortingRules.value,
            }
            getListData(data)
        }
      }else{
        handleCler()
      }
    }


    const handleQueryType = (destroyer) =>{
      if(destroyer === 'bomm'){

          // dateTimeList.value = []
          teacherName.value = ""
          cancellationsNumber.value = ""
          cancellationsMoney.value = ""

          let data = {
            pageNo: requestParameters.pageNum ? requestParameters.pageNum : 1,
            pageSize: requestParameters.pageSize ? requestParameters.pageSize : 10,
            teacherId: teacherName.value,
            startTime: dateTimeList.value[0],
            endTime: dateTimeList.value[1],
            salesNum: cancellationsNumber.value,
            salesMoney: cancellationsMoney.value,
            sortingRules: sortingRuless.value,
          }

          getListData(data)
      }
      if(destroyer === 'blast'){
          cancellationsNumber_s.value = ""
          cancellationsMoney_s.value = ""
          // dateTimeList_s.value = []
          student_s.value = ""
          student.value = ""


          let str = []
          if(student.value){
            str.push(student.value)
            if(student_s.value){
              str.push(student_s.value)
            }
          }else{
            if(student_s.value){
                str.push(student_s.value)
            }
          }

          let data = {
            pageNo: requestParameters_s.pageNum ? requestParameters_s.pageNum : 1,
            pageSize: requestParameters_s.pageSize ? requestParameters_s.pageSize : 10,
            studentList:  str.length > 0 ? str : null,
            startTime: dateTimeList_s.value[0],
            endTime: dateTimeList_s.value[1],
            salesNum: cancellationsNumber_s.value,
            salesMoney: cancellationsMoney_s.value,
            sortingRules: sortingRuless.value,
          }

          getListData(data)
      }
    }

    const store = useStore()

    let details = (row) =>{
        store.row = row
        DetailsRow = row
        ShowCourseSalesStatisticsDetails.value = true
    }

    let details_s = (row) =>{
        store.row = row
        DetailsRow = row
        ShowCourseSalesStatisticsDetails_s.value = true
    }

    let searchBtns = ()  =>{


      if(requestType.value  != 'requestType'){
        if(dateTimeList.value && dateTimeList.value.length > 0){
          let data = {
            pageNo:  1,
            pageSize: requestParameters.pageSize,
            teacherId: teacherName.value,
            // courseStartTime: dateTimeList.value[0],
            // courseEndTime: dateTimeList.value[1],
            startTime: dateTimeList.value ? dateTimeList.value[0] : '',
            endTime: dateTimeList.value ? dateTimeList.value[1] : '',
            salesNum: cancellationsNumber.value,
            salesMoney: cancellationsMoney.value,
            sortingRules: sortingRules.value,
            regionName:regionName.value || localStorage.getItem('cityTepy'),
          }
          getListData(data)
        }else{
          let data = {
            pageNo:  1,
            pageSize: requestParameters.pageSize,
            teacherId: teacherName.value,
            startTime: getMonthRange()[0],
            endTime: getMonthRange()[1],
            salesNum: cancellationsNumber.value,
            salesMoney: cancellationsMoney.value,
            sortingRules: sortingRules.value,
            regionName:regionName.value  || localStorage.getItem('cityTepy'),
          }
          getListData(data)
        }
      }else{
          let str = []
          if(student.value){
            str.push(student.value)
            if(student_s.value){
              str.push(student_s.value)
            }
          }else{
            if(student_s.value){
                str.push(student_s.value)
            }
          }

          if(dateTimeList_s.value && dateTimeList_s.value.length > 0){
            let data = {
              pageNo: 1,
              pageSize: requestParameters_s.pageSize ? requestParameters_s.pageSize : 10,
              studentList:  str.length > 0 ? str : null,
              startTime: dateTimeList_s.value[0] ? dateTimeList_s.value[0] : '',
              endTime: dateTimeList_s.value[1] ? dateTimeList_s.value[1] : '',
              salesNum: cancellationsNumber_s.value,
              salesMoney: cancellationsMoney_s.value,
              sortingRules: sortingRuless.value,
              regionName:regionName.value || localStorage.getItem('cityTepy'),
            }
            getListData(data)
          }else{
            let data = {
              pageNo: 1,
              pageSize: requestParameters_s.pageSize ? requestParameters_s.pageSize : 10,
              studentList:  str.length > 0 ? str : null,
              startTime: getMonthRange()[0],
              endTime: getMonthRange()[1],
              salesNum: cancellationsNumber_s.value,
              salesMoney: cancellationsMoney_s.value,
              sortingRules: sortingRuless.value,
              regionName:regionName.value || localStorage.getItem('cityTepy'),
            }
            getListData(data)
          }
      }


    }


    const handleOnekeyCourseConsumption = () =>{

      requestParametersalCourseConsumptionStatistics.pageNum = 1
      requestParametersalCourseConsumptionStatistics.pageSize = 10



      const loadingObj =  Loading.service({ lock: true,  text: '课消中请稍等...',  spinner: 'el-icon-loading',  background: 'rgba(0, 0, 0, 0.6)'  })

      if(typeCourseConsumptionStatistics.value === 1){
        axios.get(`${apiBaseUrl}/reality_classSales/calculateMoney`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
            if(response.data.code == 200){
              handleMessage(response.data.message, 'success')
              loadingObj.close()
              getListDataalCourseConsumptionStatistics()
            }else{
              loadingObj.close()
              handleMessage(response.data.message, 'error')
            }
        }).catch(error => {
            handleMessage(error, 'error')
            loadingObj.close()
        })
      }

      if(typeCourseConsumptionStatistics.value === 2){
        axios.get(`${apiBaseUrl}/reality_classSales/calculateHour`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
            if(response.data.code == 200){
              handleMessage(response.data.message, 'success')
              loadingObj.close()
              getListDataalCourseConsumptionStatistics()
            }else{
              loadingObj.close()
              handleMessage(response.data.message, 'error')
            }
        }).catch(error => {
            handleMessage(error, 'error')
            loadingObj.close()
        })
      }


      axios.get(`${apiBaseUrl}/reality_classSales/findCollect`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {

      if(response.data.code == 200){
          const data = response.data
          TotalAmountOfCourseCancellations.value = data.data.courseStayMoney
          TotalCourseHoursToBeCancelled.value = data.data.courseStayHour
          TodaysTotalAmountOfNewlyAddedClassExpenses.value = data.data.todayClassSalesMoney
          TodaysNewlyAddedClassHours.value = data.data.todayClassSalesHour
      }else{
          TotalAmountOfCourseCancellations.value = 0
          TotalCourseHoursToBeCancelled.value = 0
          TodaysTotalAmountOfNewlyAddedClassExpenses.value = 0
          TodaysNewlyAddedClassHours.value = 0
      }

      }).catch(error => {
          handleMessage(error, 'error')
      })

    }

    let getListDataalCourseConsumptionStatistics = (data = {
      pageSize: requestParametersalCourseConsumptionStatistics.pageSize ? requestParametersalCourseConsumptionStatistics.pageSize : 10,
      pageNum: requestParametersalCourseConsumptionStatistics.pageNum ? requestParametersalCourseConsumptionStatistics.pageNum : 1,
    }) =>{
      const URL = `/reality_classSales/${typeCourseConsumptionStatistics.value === 1 ? 'findCourseMoneyPage' : 'findCourseHourPage'}`
      axios.post(`${apiBaseUrl}${URL}`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(response => {
        let data = response.data
        if (data.code == 200) {
              handleMessage('查询成功', 'success')
              if( data.data.records && data.data.records.length > 0 ){
                  requestParametersalCourseConsumptionStatistics.total = data.data.total
                  requestParametersalCourseConsumptionStatistics.pageNum = data.data.current
                  requestParametersalCourseConsumptionStatistics.pageSize = data.data.size
                  dataListactualCourseConsumptionStatistics.value = data.data.records
              }else{
                  requestParametersalCourseConsumptionStatistics.total = 0
                  requestParametersalCourseConsumptionStatistics.pageNum = 1
                  requestParametersalCourseConsumptionStatistics.pageSize = 10
                  dataListactualCourseConsumptionStatistics.value = []
              }
          }else{
            handleMessage('查询失败', 'error')
        }
        })
        .catch(error => {
          handleMessage(error, 'error')
        });
    }


    let getListData = (data = {
        pageSize: requestParameters.pageSize, pageNo: requestParameters.pageNum,
        teacherId: teacherName.value,
        // courseStartTime: dateTimeList.value[0],
        // courseEndTime: dateTimeList.value[1],
        startTime: dateTimeList.value[0],
        endTime: dateTimeList.value[1],
        salesNum: cancellationsNumber.value,
        salesMoney: cancellationsMoney.value,
        sortingRules: requestType.value  === 'requestType' ? sortingRuless.value : sortingRules.value,
        regionName: regionName.value || localStorage.getItem('cityTepy'),
    }) => {
      let URL = ''
      if(requestType.value  === 'requestType'){
            TimeList.value = dateTimeList_s.value
            URL = '/classSales/queryStuClassSales'
      }else{
            TimeList.value = dateTimeList.value
            URL = '/classSales/queryClassSales'
      }

      axios.post(`${apiBaseUrl}${URL}`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(response => {

        let list = response.data
        if (list.code == 200) {
              handleMessage('查询成功', 'success')
              if(requestType.value  === 'requestType'){
                  requestParameters_s.total = list.data.allTotal
                  requestParameters_s.pageNum = list.data.pageIndex
                  dataTop_s.actualNumCount = list.data.actualNumCount ? list.data.actualNumCount : 0
                  dataTop_s.actualMoneyCount = list.data.actualMoneyCount ? list.data.actualMoneyCount : 0
                  dataTop_s.notNumCount = list.data.notNumCount ? list.data.notNumCount : 0
                  dataTop_s.notMoneyCount = list.data.notMoneyCount ? list.data.notMoneyCount : 0
                  dataTop_s.estimateNumCount = list.data.estimateNumCount ? list.data.estimateNumCount : 0
                  dataTop_s.estimateMoneyCount = list.data.estimateMoneyCount ? list.data.estimateMoneyCount : 0
                  dataList_s.value = list.data.classSales
              }else{
                  requestParameters.total = list.data.allTotal
                  requestParameters.pageNum = list.data.pageIndex
                  dataTop.actualNumCount = list.data.actualNumCount ? list.data.actualNumCount : 0
                  dataTop.actualMoneyCount = list.data.actualMoneyCount ? list.data.actualMoneyCount : 0
                  dataTop.notNumCount = list.data.notNumCount ? list.data.notNumCount : 0
                  dataTop.notMoneyCount = list.data.notMoneyCount ? list.data.notMoneyCount : 0
                  dataTop.estimateNumCount = list.data.estimateNumCount ? list.data.estimateNumCount : 0
                  dataTop.estimateMoneyCount = list.data.estimateMoneyCount ? list.data.estimateMoneyCount : 0
                  dataList.value = list.data.classSales
              }
          }else{
            handleMessage('查询失败', 'error')
        }
        })
        .catch(error => {
          console.error(error)
        });
    }

    let handleMessage = (message , type)=>{
      $Vue.$message({ message, type, duration: 500 })

    }


    let handleGetTeacher = () =>{
      getTeachers_s().then((res) => {
        teacherArr.value = res.data
      })
    }


    let handleCurrentChange = (current) =>{
        requestParameters.pageNum = current
        getListData()
    }


    let handleCurrentChangealCourseConsumptionStatistics = (current) =>{
        requestParametersalCourseConsumptionStatistics.pageNum = current
        getListDataalCourseConsumptionStatistics()
    }

    let handleSizeChangealCourseConsumptionStatistics = (current) =>{
        requestParametersalCourseConsumptionStatistics.pageNum = current
        getListDataalCourseConsumptionStatistics()
    }


    let handleSizeChange = (Size) =>{
        requestParameters.pageSize = Size
        getListData()
    }

    let handleCurrentChange_s = (current) =>{
        requestParameters_s.pageNum = current
        let str = []
          if(student.value){
            str.push(student.value)
            if(student_s.value){
              str.push(student_s.value)
            }
          }else{
            if(student_s.value){
                str.push(student_s.value)
            }
          }
        let data = {
              pageNo: requestParameters_s.pageNum ? requestParameters_s.pageNum : 1,
              pageSize: requestParameters_s.pageSize ? requestParameters_s.pageSize : 10,
              studentList:  str.length > 0 ? str : null,
              startTime: dateTimeList_s.value[0] ? dateTimeList_s.value[0] : '',
              endTime: dateTimeList_s.value[1] ? dateTimeList_s.value[1] : '',
              salesNum: cancellationsNumber_s.value,
              salesMoney: cancellationsMoney_s.value,
            }
            getListData(data)
    }

    let handleSizeChange_s = (Size) =>{
        requestParameters_s.pageSize = Size
        let str = []
          if(student.value){
            str.push(student.value)
            if(student_s.value){
              str.push(student_s.value)
            }
          }else{
            if(student_s.value){
                str.push(student_s.value)
            }
          }
        let data = {
              pageNo: requestParameters_s.pageNum ? requestParameters_s.pageNum : 1,
              pageSize: requestParameters_s.pageSize ? requestParameters_s.pageSize : 10,
              studentList:  str.length > 0 ? str : null,
              startTime: dateTimeList_s.value[0] ? dateTimeList_s.value[0] : '',
              endTime: dateTimeList_s.value[1] ? dateTimeList_s.value[1] : '',
              salesNum: cancellationsNumber_s.value,
              salesMoney: cancellationsMoney_s.value,
            }
            getListData(data)
    }


    let handleEmitButs = (event, destroyer) =>{
        ShowCourseSalesStatisticsDetails.value = event
        ShowCourseSalesStatisticsDetails_s.value = event

        handleQueryType(destroyer)

    }


    let handleClickTab = (type)=>{
        if(type === 1 || type === 2){
            requestParametersalCourseConsumptionStatistics.total = 0
            requestParametersalCourseConsumptionStatistics.pageNum = 1
            requestParametersalCourseConsumptionStatistics.pageSize = 10
            dataListactualCourseConsumptionStatistics.value = []
            typeCourseConsumptionStatistics.value = type
            getListDataalCourseConsumptionStatistics()
        }
    }


    let changeSortingRules = (event) =>{
      getListData()
    }

    let changeSortingRuless = (event) =>{
      getListData()
    }


    return {
      handleClickTab,
      requestParameters,
      dateTimeList,
      teacherName,
      cancellationsNumber,
      cancellationsMoney,
      dataList,
      teacherArr,
      ShowCourseSalesStatisticsDetails,
      ShowCourseSalesStatisticsDetails_s,
      DetailsRow,
      TimeList,
      dataTop,
      activeName,
      getStudentsArr,
      getStudentsArr_s,
      student,
      student_s,
      cancellationsNumber_s,
      cancellationsMoney_s,
      dateTimeList_s,
      requestParameters_s,
      handleCurrentChange_s,
      handleSizeChange_s,
      dataTop_s,
      dataList_s,

      exportBtnss,
      exportBtns,
      searchBtns,
      clearBtns,
      getListData,

      handleEmitButs,
      details,
      details_s,
      formatDate,
      handleCurrentChange,
      handleSizeChange,

      handleMessage,
      handleGetTeacher,
      handleClick,
      handleTpyeCler,
      handleInit,

      handleInitList,
      dataListactualCourseConsumptionStatistics,
      handleCurrentChangealCourseConsumptionStatistics,
      handleSizeChangealCourseConsumptionStatistics,
      requestParametersalCourseConsumptionStatistics,
      handleOnekeyCourseConsumption,
      typeCourseConsumptionStatistics,

      TotalAmountOfCourseCancellations,
      TotalCourseHoursToBeCancelled,
      TodaysTotalAmountOfNewlyAddedClassExpenses,
      TodaysNewlyAddedClassHours,

      sortingRules,
      sortingRulesArr,
      changeSortingRules,
      sortingRuless,
      changeSortingRuless,


      optionsListt,
      regionName,

    }



  }

}


</script>

<style scoped>
.select {
  display: flex;
  flex-wrap: wrap;
}

@media screen and (max-width: 750px) {
  .sales-statistics {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.sales-statistics {
    width: 70% !important;
  }
}

.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}



.glow-effect {
  position: relative;
  overflow: hidden;
}

.glow-effect::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, #0fb2f6, #18dec5, #0fb2f6);
  background-size: 400% 400%;
  animation: glow 5s ease-in-out infinite;
  z-index: -1;
}

@keyframes glow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.clickable-text {
  color: red;
  cursor: pointer;
}






</style>



// WEBPACK FOOTER //
// src/manager/createComponents/CourseSalesStatistics.vue